import React from 'react';
import { Shield, Target, Clock, Settings, Map, Heart } from 'lucide-react';
export function WhyChoose() {
  const cards = [{
    icon: <Shield className="w-6 h-6 text-primary-600" data-id="element-792" />,
    title: 'Commercial Glass Specialists',
    copy: 'Storefront glass, office glass walls, commercial doors, windows, curtain walls and contract glazing handled by experienced glass professionals.'
  }, {
    icon: <Target className="w-6 h-6 text-primary-600" data-id="element-793" />,
    title: 'Accurate Quotes',
    copy: 'Clear scope review, measurements and bid details help your team understand the work before the project begins.'
  }, {
    icon: <Clock className="w-6 h-6 text-primary-600" data-id="element-794" />,
    title: 'Reliable Installations',
    copy: 'Commercial glass repair, replacement and glazing work planned around your building, tenant or construction schedule.'
  }, {
    icon: <Settings className="w-6 h-6 text-primary-600" data-id="element-795" />,
    title: 'Design, Fabrication & Installation',
    copy: 'From simple storefront repair to full glazing systems, Kosin’s Glass supports design, fabrication, installation and service.'
  }, {
    icon: <Map className="w-6 h-6 text-primary-600" data-id="element-796" />,
    title: 'Local Presence, Larger Capabilities',
    copy: 'Offices in Howell, Ann Arbor and Novi support Southeast Michigan projects, with commercial glazing capabilities available for select larger projects.'
  }, {
    icon: <Heart className="w-6 h-6 text-primary-600" data-id="element-797" />,
    title: 'Family-Owned Since 2000',
    copy: 'A Michigan glass company focused on quality work, professional service and long-term customer relationships.'
  }];
  return <section className="py-20 bg-white border-t border-slate-200" data-id="element-798">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-799">
        <div className="text-center mb-16 anim-on-scroll" data-id="element-800">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900" data-id="element-801">
            Why Businesses Choose Kosin’s Glass
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-802">
          {cards.map((card, idx) => <div key={idx} className="bg-slate-50 rounded-xl p-6 border border-slate-200 scroll-fade-up" style={{
          animationDelay: `${idx * 0.1}s`
        }} data-id="element-803">
              <div className="w-12 h-12 bg-white rounded-lg border border-slate-200 flex items-center justify-center mb-5 shadow-sm" data-id="element-804">
                {card.icon}
              </div>
              <h3 className="kosins-heading text-2xl text-neutral-900 mb-3" data-id="element-805">
                {card.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-806">
                {card.copy}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}